import React, { Component } from 'react'
import { message, Form, Input, Button } from 'antd'
import { connect } from 'dva'
import { login, logout } from '../../services/login'
const _ = require('underscore')

const FormItem = Form.Item;

class ProfileConfig extends Component {

    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    constructor (props) {
        super(props);

        this.state = {};
    }


    handlePasswordBlur(e) {
        const value = e.target.value;
        this.setState({
            passwordDirty: this.state.passwordDirty || !!value
        });
    }

    checkPassword(rule, value, callback) {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newpassword')) {
            callback('Las contraseñas no coinciden!');
        } else {
            callback();
        }
    }

    checkConfirm(rule, value, callback) {
        const form = this.props.form;
        if (value && this.state.passwordDirty) {
            form.validateFields(['confirm'], {force: true});
        }
        callback();
    }


	/**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            let data = {};
            data.username = this.props.app.user.username;
            data.password = values.password;

            login(data).then(resp => {
                logout(resp.sessionToken);                

                _.extend(this.props.app.user, {password: values.newpassword});
                this.props.dispatch({type: 'user/update', payload: this.props.app.user})
                localStorage.setItem('currentUser', JSON.stringify(this.props.app.user));

            }).catch(e => {
                console.log('err', e);             
                message.error('La contraseña actual que ingresó no coincide con la registrada')    
            });
        })
    }


  	/**
    * Render del componente
    */
    render () {
	    return (
            <div>
                <div className="col-md-12">
		    		<div className="col-md-4">
				    	<FormItem label="Contraseña actual" hasFeedback>
	                        {this.props.form.getFieldDecorator('password', {
	                            rules: [{
	                                required: true,
	                                message: 'Por favor, ingrese su contraseña actual',
	                            }]
	                        })(<Input size='large' type='password' onPressEnter={this.handleSubmit.bind(this)} />)}
	                    </FormItem>
                	</div>

		    		<div className="col-md-4">
				    	<FormItem label="Nueva contraseña" hasFeedback>
	                        {this.props.form.getFieldDecorator('newpassword', {
	                            rules: [{
	                                required: true,
	                                message: 'Por favor, ingrese mínimo 6 caracteres para su nueva contraseña',
	                                min: 6
	                            }, {
	                                validator: this.checkConfirm.bind(this)
	                            }]
	                        })(<Input size='large' type='password' onBlur={this.handlePasswordBlur.bind(this)} onPressEnter={this.handleSubmit.bind(this)} />)}
	                    </FormItem>
                	</div>

					<div className="col-md-4">
	                    <FormItem label="Confirmar contraseña" hasFeedback>
	                        {this.props.form.getFieldDecorator('confirm', {
	                            rules: [{
	                                required: true,
	                                message: 'Por favor, vuelva a escribir su nueva contraseña',
	                                min: 6
	                            }, {
	                                validator: this.checkPassword.bind(this)
	                            }]
	                        })(<Input size='large' type='password' onPressEnter={this.handleSubmit.bind(this)} />)}
	                    </FormItem>
	                </div>
	            </div>
                
                <div className="row text-center marginBottom30">
                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.buttonLoading} className={'btn btn-primary btn-flat'}>
                        Actualizar contraseña
                    </Button>
                </div>
            </div>
	    )
	}
}

export default connect(({currentInvoice, app}) => ({currentInvoice, app}))(Form.create()(ProfileConfig))


// WEBPACK FOOTER //
// ./src/components/profile/profileConfig.js